var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "学生",
                            prop: "student.id",
                            rules: [
                              {
                                required: true,
                                message: "学生不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("GridSelect", {
                            attrs: {
                              title: "选择学生",
                              labelName: "name",
                              labelValue: "id",
                              value: _vm.inputForm.student.id,
                              limit: 1,
                              columns: [
                                {
                                  prop: "name",
                                  label: "姓名",
                                },
                              ],
                              searchs: [
                                {
                                  prop: "name",
                                  label: "姓名",
                                },
                              ],
                              dataListUrl: "/test/manytomany/student/list",
                              queryEntityUrl:
                                "/test/manytomany/student/queryById",
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.student.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "课程",
                            prop: "course.id",
                            rules: [
                              {
                                required: true,
                                message: "课程不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("GridSelect", {
                            attrs: {
                              title: "选择课程",
                              labelName: "name",
                              labelValue: "id",
                              value: _vm.inputForm.course.id,
                              limit: 1,
                              columns: [
                                {
                                  prop: "name",
                                  label: "课程名",
                                },
                              ],
                              searchs: [
                                {
                                  prop: "name",
                                  label: "课程名",
                                },
                              ],
                              dataListUrl: "/test/manytomany/course/list",
                              queryEntityUrl:
                                "/test/manytomany/course/queryById",
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.course.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "分数",
                            prop: "score",
                            rules: [
                              {
                                required: true,
                                message: "分数不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validator.isDigits,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写分数" },
                            model: {
                              value: _vm.inputForm.score,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "score", $$v)
                              },
                              expression: "inputForm.score",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注信息",
                            prop: "remarks",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写备注信息",
                            },
                            model: {
                              value: _vm.inputForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "remarks", $$v)
                              },
                              expression: "inputForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }